import { discountedSalePrice, perMonthAmount } from "./paddlePrice";

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function timeLeft(endsAtMs, nowMs) {
  const remaining = Math.max(0, endsAtMs - nowMs);

  return {
    days: Math.floor(remaining / DAY),
    hours: Math.floor((remaining % DAY) / HOUR),
    isOver: remaining === 0,
    minutes: Math.floor((remaining % HOUR) / MINUTE),
    seconds: Math.floor((remaining % MINUTE) / SECOND)
  };
}

export function twoDigits(value) {
  return String(value).padStart(2, "0");
}

export function formatMoney(amount, currency, locale) {
  return new Intl.NumberFormat(locale, { currency, style: "currency" }).format(amount);
}

// The sale price is Paddle's own, from the regional price point the coupon applies to.
export function planPrices(product, { couponCode, locale }) {
  const listPrice = product.subscription ? product.subscription.list_price.gross : product.list_price.gross;
  const salePrice = couponCode ? discountedSalePrice(product, { couponCode, discountPct: null }) : null;
  const yearlyTotal = salePrice === null ? listPrice : salePrice;
  const isYearly = !!(product.subscription && product.subscription.interval === "year");
  const decimals = new Intl.NumberFormat(locale, { currency: product.currency, style: "currency" })
    .resolvedOptions().maximumFractionDigits;
  const format = (amount) => formatMoney(amount, product.currency, locale);

  return {
    list: format(listPrice),
    perMonth: isYearly ? format(perMonthAmount(yearlyTotal, decimals)) : null,
    sale: salePrice === null ? null : format(salePrice)
  };
}

const PADDLE_LOCALES = ["de", "es", "fr", "it", "pl", "pt"];

export function paddleLocale(locale) {
  return PADDLE_LOCALES.includes(locale) ? locale : undefined;
}
